import { combineReducers } from 'redux'
import {
  DEPOT_PAGE_ERROR, DEPOT_PAGE_LOADING, DEPOT_LIST_SUCCESS,
  DEPOT_VIEW_SUCCESS, DEPOT_PAGE_SUCCESS, DEPOT_VIEW_ERROR,
  DEPOT_ADD_ERROR, DEPOT_ADD_LOADING, DEPOT_ADD_SUCCESS,
  DEPOT_VIEW_LOADING, DEPOT_DELETE_ERROR, DEPOT_DELETE_LOADING, 
  DEPOT_DELETE_SUCCESS, DEPOT_UPDATE_SUCCESS, DEPOT_UPDATE_ERROR, DEPOT_UPDATE_LOADING, DEPOT_LIST_ERROR, DEPOT_LIST_LOADING
} from './constant'

const depotPageError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_PAGE_ERROR:
      return action.depotPageError
    default:
      return state
  }
}

const depotPageLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_PAGE_LOADING:
      return action.depotPageLoading
    default:
      return state
  }
}

const depotPageSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_PAGE_SUCCESS:
      return action.depotPageSuccess
    default:
      return state
  }
}

const depots = (state = [], action) => {
  switch (action.type) {
    case DEPOT_PAGE_SUCCESS:
      return action.depot
    case DEPOT_LIST_SUCCESS:
      return action.depot
    default:
      return state
  }
}

const depot = (state = [], action) => {
  switch (action.type) {
    case DEPOT_VIEW_SUCCESS:
      return action.depot
    default:
      return state
  }
}

const depotAddError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_ADD_ERROR:
      return action.depotAddError
    default:
      return state
  }
}

const depotAddLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_ADD_LOADING:
      return action.depotAddLoading
    default:
      return state
  }
}

const depotAddSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_ADD_SUCCESS:
      return action.depotAddSuccess
    default:
      return state
  }
}

const depotViewError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_VIEW_ERROR:
      return action.depotViewError
    default:
      return state
  }
}

const depotViewLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_VIEW_LOADING:
      return action.depotViewLoading
    default:
      return state
  }
}

const depotViewSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_VIEW_SUCCESS:
      return action.depotViewSuccess
    default:
      return state
  }
}

const depotDeleteError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_DELETE_ERROR:
      return action.depotDeleteError
    default:
      return state
  }
}

const depotDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_DELETE_LOADING:
      return action.depotDeleteLoading
    default:
      return state
  }
}

const depotDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_DELETE_SUCCESS:
      return action.depotDeleteSuccess
    default:
      return state
  }
}

const depotUpdateError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_UPDATE_ERROR:
      return action.depotUpdateError
    default:
      return state
  }
}

const depotUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_UPDATE_LOADING:
      return action.depotUpdateLoading
    default:
      return state
  }
}

const depotUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_UPDATE_SUCCESS:
      return action.depotUpdateSuccess
    default:
      return state
  }
}

const depotListError = (state = false, action) => {
  switch (action.type) {
    case DEPOT_LIST_ERROR:
      return action.depotListError
    default:
      return state
  }
}

const depotListLoading = (state = false, action) => {
  switch (action.type) {
    case DEPOT_LIST_LOADING:
      return action.depotListLoading
    default:
      return state
  }
}

const depotListSuccess = (state = false, action) => {
  switch (action.type) {
    case DEPOT_LIST_SUCCESS:
      return action.depotListSuccess
    default:
      return state
  }
}

const depotReducer = combineReducers({
  depotPageError,
  depotPageLoading,
  depotPageSuccess,

  depots,
  depot,

  depotAddError,
  depotAddLoading,
  depotAddSuccess,

  depotViewError,
  depotViewLoading,
  depotViewSuccess,

  depotDeleteError,
  depotDeleteLoading,
  depotDeleteSuccess,

  depotUpdateError,
  depotUpdateLoading,
  depotUpdateSuccess,

  depotListError,
  depotListLoading,
  depotListSuccess,
})

export default depotReducer
